export default __webpack_public_path__ + "static/media/screenshot4.4ce53d29.jpg";